import { useState, useRef, useCallback, useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import {
  escapeCitationsForMarkdown,
  buildMarkdownComponents,
} from "./CitationButton";

const FormattedMessage = ({
  text,
  citations,
  onSourceClick,
  activeSourceId,
  citationInteractions,
  onOpenInEditor,
}) => {
  const [hoveredCiteIndex, setHoveredCiteIndex] = useState(null);
  const hoveredRef = useRef(null);

  const citationMap = useMemo(() => {
    if (!citations || citations.length === 0) return {};
    const map = {};
    citations.forEach((c) => {
      map[c.index] = c;
    });
    return map;
  }, [citations]);

  const onHoverIn = useCallback((idx) => {
    hoveredRef.current = idx;
    setHoveredCiteIndex(idx);
  }, []);
  const onHoverOut = useCallback(() => {
    hoveredRef.current = null;
    setHoveredCiteIndex(null);
  }, []);

  // Build components only once per citationMap — NOT on hover changes
  const components = useMemo(
    () =>
      buildMarkdownComponents(
        citationMap,
        hoveredRef,
        onHoverIn,
        onHoverOut,
        onSourceClick,
        activeSourceId,
        citationInteractions,
        onOpenInEditor,
      ),
    [
      citationMap,
      onHoverIn,
      onHoverOut,
      onSourceClick,
      activeSourceId,
      citationInteractions,
      onOpenInEditor,
    ],
  );

  // Escape [N] → @@CITE:N@@ so markdown doesn't eat them as link refs
  const escaped = useMemo(
    () =>
      citations && citations.length > 0
        ? escapeCitationsForMarkdown(text)
        : text,
    [text, citations],
  );

  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {escaped}
    </ReactMarkdown>
  );
};

export default FormattedMessage;
